// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VU5f","rootMobile":"styles_rootMobile__2IIop"};